



































































import { BusinessUnit } from "@/shared/models/businessUnit";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  ComposedMessage,
  MessageSourceTypeEnum,
  MessageViewModel,
  NewMessageModel
} from "./types";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import ScrollLoader from "@/components/misc/ScrollLoader.vue";
import { Getter } from "vuex-class";
import { formatDateTimeAccordingToTimeZoneOrUTC } from '@/shared/dateFormatUtils';
import { ListModel } from "@/shared/models/listModel";
import { NotificationTemplateViewModel } from "./templates/types";

@Component({
  components: {
    RightDrawer,
    ScrollLoader,
  },
})
export default class ConversationPanelWhatsApp extends Vue {
  @Prop({ default: false }) open!: boolean;
  @Prop() phoneNumber?: string;
  @Prop() customerName?: string;
  @Prop() customerId?: number | null;
  @Prop({ default: null }) reservationId?: number | null;

  model: MessageViewModel[] | null = null;
  loading = false;
  initialLoadDone = false;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("language/language") language?: string;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    this.newMessage = '';
    this.templateId = 0;

    if (fresh && !old) {
      await this.load(false);
      this.loadTemplates();

      this.setMessageReceiverInterval();      
    } else {
      this.model = null;      
      this.loading = false;
      
      this.clearMessageReceiverInterval();
    }
  }

  templateId = 0;
  templates = [] as NotificationTemplateViewModel[];

  get filteredTemplates() {
    return this.templates.filter((x) => x.sourceTypeIds?.includes(MessageSourceTypeEnum.WhatsApp))
  }

  messageInterval = 0;

  setMessageReceiverInterval() {
    this.clearMessageReceiverInterval();

    this.messageInterval = setInterval(() => {
      this.load(true);
    }, 10000);
  }

  clearMessageReceiverInterval() {
    if (this.messageInterval) {
        clearInterval(this.messageInterval);  
      }
  }

  loadTemplates() {
    this.axios
      .get<ListModel<NotificationTemplateViewModel>>("/notificationTemplates", {})
      .then((res) => {
        this.templates = res.data.result;
      });
  }

  blockFreeFormMessages() {
    // if the last message is older than 24h, free form messages are not allowed by WhatsApp policy, rather templated message must be sent to the customer
    if (this.model && this.model.length > 0) {
      const lastMessageDate = new Date(new Date(this.model[this.model.length - 1].date + 'Z')); // adding 'Z' to original string tells JS that it's UTC date string
      const now = new Date();
      const hours = Math.abs(now.getTime() - lastMessageDate.getTime()) / 36e5;
      
      return hours > 24;
    }

    return true
  }

  async load(onlyNewMessages: boolean){
    this.loading = true;
    let uri = "/messages/whatsapp?phoneNumber=" + encodeURIComponent(this.phoneNumber ?? '');
    
    if (onlyNewMessages && this.model && this.model.length > 0) {
      uri = uri + '&onlyNewerThanMessageId=' + this.model[this.model.length - 1].id;
    }

    await this.axios
      .get<ListModel<MessageViewModel>>(uri)
      .then((res) => {
        if (onlyNewMessages && this.model) {
          this.model.push(...res.data.result);
        } else {
          this.model = res.data.result;
        }
        this.initialLoadDone = true;

        setTimeout(() => {
          this.scrollEl?.scrollTo(0, this.scrollEl.scrollHeight);
        }, 0);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  close() {
    this.$emit("update:open", false);
  }

  newMessage = '';
  async send() {
    this.clearMessageReceiverInterval();

    this.loading = true;

    const message = new NewMessageModel();
    message.body = this.newMessage;
    message.sourceTypeId = MessageSourceTypeEnum.WhatsApp;
    message.to = [this.phoneNumber ?? ''];
    message.reservationId = this.reservationId ?? null;
    message.notificationTemplateId = this.templateId && this.templateId != 0 ? this.templateId : null;
    message.cultureCode = this.templateLanguage;
    message.customerId = this.customerId ?? null;

    await this.axios
    .post("/messages/sendmessage", message)
    .then(() => {
      this.newMessage = '';
      this.templateId = 0;
    })
    .finally(() => {
      this.load(true);
      this.setMessageReceiverInterval();
    });
  }

  scrollEl = null as HTMLElement | null;
  mounted() {
    this.scrollEl = this.$refs.messages as HTMLElement;
  }

  unmounted() {
    this.clearMessageReceiverInterval();
  }

  // todo: language picker should be implemented and template language resolver server side for WA
  // hardcoded for now
  templateLanguage = "en-GB";
  
  templateLoading = false;

  onTemplateChange() {
    if (!this.templateId || !this.reservationId) {
      this.newMessage = "";
      return;
    }

    this.templateLoading = true;

    this.axios
      .get<ComposedMessage>("notificationTemplates/GetComposedMessage", {
        params: {
          templateId: this.templateId,
          reservationId: this.reservationId,
          cultureCode: this.templateLanguage ?? "en",
        },
      })
      .then((res) => {
        this.newMessage = res.data.body;
      })
      .finally(() => {
        this.templateLoading = false;
      });
  }

  formatTimezoneFromUtcToLocal(date: Date){
    const unformatedTimeZone = this.activeBusinessUnit?.timeZoneId;
    const timeZone = unformatedTimeZone ? unformatedTimeZone.substring(0, unformatedTimeZone.indexOf(",")) : undefined;
    return formatDateTimeAccordingToTimeZoneOrUTC(date, this.language ?? "", timeZone);
  }
}
